import PubSub from "underpub-js";

var HeroComplex = function (options) {
    this.options = {
        $el: false,
        baseClass: "mol-HeroComplex",
    };
    $.extend(true, this.options, options);
};

HeroComplex.prototype.init = function () {
    var self = this;
    self.updateMinHeight();

    // Add event listener for window resize
    $(window).on("resize", function () {
        self.updateMinHeight();
    });
};

HeroComplex.prototype.updateMinHeight = function () {
    var bannerHeight = $(".mol-Banner").outerHeight(true);
    var minHeight = `calc(100vh - ${bannerHeight}px)`;

    // Update the CSS property dynamically
    $("<style>")
        .prop("type", "text/css")
        .html(`.mol-HeroComplex:before { min-height: ${minHeight}; }`)
        .appendTo("head");
};

export default HeroComplex;
